import React from 'react';
import { bool, number, string } from 'prop-types';
import cn from 'classnames';
import { isEmpty } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { Tooltip } from '@fiverr-private/tooltip';
import { getSellerLevelText, levels } from '../../helpers';

import classes from './index.module.scss';

export const SellerLevel = ({
    achievement,
    className = '',
    isPro = false,
    isLimitedEdition = false,
    isNewSeller = false,
    tooltipPosition = 'top'
}) => {
    const { locale } = getContext();
    const { sellerLevelText, sellerLevelTooltipText } = getSellerLevelText(achievement, isPro, isLimitedEdition, isNewSeller);

    const SellerLevelDescription = () => (
        <div className={cn('user-profile-image', classes.sellerLevel, { [classes.topRated]: achievement === levels['top-rated-seller'] }, className)}>
            <I18n locale={locale} k={sellerLevelText}/>
        </div>
    );

    if (isEmpty(sellerLevelText)) {
        return null;
    }

    if (isEmpty(sellerLevelTooltipText)) {
        return <SellerLevelDescription/>;
    }

    return (
        <Tooltip content={<div className={classes.sellerLevelTooltip}><I18n locale={locale} k={sellerLevelTooltipText}/></div>}
            position={tooltipPosition}>
            <SellerLevelDescription/>
        </Tooltip>
    );
};

SellerLevel.propTypes = {
    achievement: number,
    className: string,
    isPro: bool,
    isLimitedEdition: bool,
    isNewSeller: bool,
    tooltipPosition: string
};

export default SellerLevel;
